var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.122 0H6.42C2.875 0 0 2.799 0 6.25v7.5C0 17.201 2.875 20 6.42 20h7.702c3.545 0 6.42-2.799 6.42-6.25v-7.5c0-3.451-2.875-6.25-6.42-6.25zm4.494 13.75c0 2.413-2.016 4.375-4.494 4.375H6.42c-2.478 0-4.493-1.962-4.493-4.375v-7.5c0-2.413 2.015-4.375 4.493-4.375h7.703c2.478 0 4.494 1.962 4.494 4.375v7.5z","key":0}),React.createElement("path",{"d":"M10.564 5.143c-2.917 0-5.282 2.303-5.282 5.143s2.365 5.143 5.282 5.143 5.282-2.303 5.282-5.143-2.365-5.143-5.282-5.143zm0 8.357c-1.82 0-3.301-1.443-3.301-3.214 0-1.773 1.482-3.215 3.301-3.215 1.82 0 3.302 1.442 3.302 3.215 0 1.771-1.482 3.214-3.302 3.214z","key":1}),React.createElement("ellipse",{"cx":"15.846","cy":"4.571","rx":"1","ry":"1","key":2})]);
}

Instagram.defaultProps = {"viewBox":"0 0 21 20"};

module.exports = Instagram;

Instagram.default = Instagram;
